









































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fetchCambioServicio } from './fetchCambioServicio';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import moment from 'moment';
import { Snotify } from '@/snotify/Snotify';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class EquipoCliente extends Vue {
  constructor() {
    super();
  }

  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: null }) estado: any;
  @Prop({ default: null }) serienumero!: any;
  @Prop({ default: null }) tipoeqid!: any;
  @Prop({ default: null }) accion_de_cambio!: any;
  @Prop({ default: 'Equipo Instalado' }) titulo!: any;

  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify;

  lista_tipoeqname: any = null;
  detalle: boolean = false;

  formFields: FormFieldDefMap = {
    model_serienumero: {
      label: 'Serie Número*',
      id: '',
      value: '',
    },
    model_tipoeqname: {
      label: 'Tipo de Equipo',
      id: '',
      value: '',
    },
    serie_activa_numero: {
      label: 'Serie Activa Número',
      id: '',
      value: '',
    },
    serie_activa_modalidad: {
      label: 'Modalidad',
      id: '',
      value: '',
    },
    serie_activa_plataforma: {
      label: 'Plataforma',
      id: '',
      value: '',
    },
    serieactivaplata_ingresada: {
      label: 'Ingresada en Plataforma',
      id: '',
      value: '',
    },
    serieactivaplata_fecha: {
      label: 'Fecha en Plataforma',
      id: '',
      value: '',
    },
    serieactivaid_dispositivo: {
      label: 'ID de dispositivo',
      id: '',
      value: '',
    },
    serieactivaepc: {
      label: 'EPC',
      id: '',
      value: '',
    },
    sim_serie_numero: {
      label: 'Sim Serie Número',
      id: '',
      value: '',
    },
    sim_estado: {
      label: 'Sim Estado',
      id: '',
      value: '',
    },
    patente: {
      label: 'Patente Vehículo',
      id: '',
      value: '',
    },
    flota: {
      label: 'Flota Id',
      id: '',
      value: '',
    },

    clienterut: {
      label: 'RUT Cliente',
      id: '',
      value: '',
    },
    nombrecliente: {
      label: 'Cliente',
      id: '',
      value: '',
    },
    clienteid: {
      label: 'ID Cliente',
      id: '',
      value: '',
    },
    serieactivafecha_baja: {
      label: 'Fecha de Baja',
      id: '',
      value: '',
    },
    serieactivaobs: {
      label: 'Observación',
      id: '',
      value: '',
    },
    nombre_flota: {
      label: 'Flota',
      id: '',
      value: '',
    },
  };

  async buscar_serie_numero() {
    //MicroServicios/catalogo/conectaCambioServicio.py
    this.loadingService.showLoading(undefined, 'buscar_serie_numero');
    return fetchCambioServicio(
      { numero_serie: this.formFields.model_serienumero.value },
      'conectaCambioServicio/buscar_equipo_por_serie'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading('buscar_serie_numero');
          this.lista_tipoeqname = data.data.LISTA;
        } else {
          this.loadingService.hideLoading('buscar_serie_numero');
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('buscar_serie_numero');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('buscar_serie_numero');
        return null;
      });
  } //end buscar_serie_numero

  async get_equipo_activa() {
    this.loadingService.showLoading();
    let self = this;
    return fetchCambioServicio(
      {
        serienumero: this.formFields.model_serienumero.value,
        tipoedid: this.formFields.model_tipoeqname.value,
        editando: this.editando,
      },
      'conectaCambioServicio/get_equipo_activa'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();

          self.formFields.serie_activa_numero.value =
            data.data.LISTA[0]['serieactivanro'];
          self.formFields.flota.value = data.data.LISTA[0]['flota_id'];

          self.formFields.serie_activa_modalidad.value =
            data.data.LISTA[0]['serieactivamodalidad'];

          self.formFields.serie_activa_plataforma.value =
            data.data.LISTA[0]['serieactivaplataforma'];

          if (data.data.LISTA[0]['serieactivaplata_ingresada'] == 'S') {
            self.formFields.serieactivaplata_ingresada.value =
              data.data.LISTA[0]['serieactivaplata_ingresada'];
          } else {
            self.formFields.serieactivaplata_ingresada.value = '';
          }
          self.formFields.serieactivaplata_fecha.value = moment(
            data.data.LISTA[0]['serieactivaplata_fecha']
          ).format('YYYY/MM/DD HH:mm:ss');
          self.formFields.serieactivaid_dispositivo.value =
            data.data.LISTA[0]['serieactivaid_dispositivo'];
          self.formFields.nombre_flota.value =
            data.data.LISTA[0]['nombre_flota'];
          self.formFields.serieactivaepc.value =
            data.data.LISTA[0]['serieactivaepc'];
          self.formFields.sim_serie_numero.value =
            data.data.LISTA[0]['simserienumero'];
          self.formFields.nombrecliente.value =
            data.data.LISTA[0]['nombre_cliente'];

          self.formFields.patente.value =
            data.data.LISTA[0]['patente_vehiculo'];
          self.formFields.sim_estado.value = data.data.LISTA[0]['simestado'];
          self.formFields.clienterut.value = data.data.LISTA[0]['rut_ve'];
          self.formFields.clienteid.value = data.data.LISTA[0]['clienteid'];
          self.formFields.serieactivafecha_baja.value = moment(
            data.data.LISTA[0]['serieactivafecha_baja']
          ).format('DD/MM/YYYY HH:mm:ss');
          self.formFields.serieactivaobs.value =
            data.data.LISTA[0]['serieactivaobs'];
          if (this.accion_modal == 'EDITAR') {
            self.formFields.model_tipoeqname.value =
              data.data.LISTA[0]['nombre_equipo'];
          }
        } else {
          this.loadingService.hideLoading();
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  enviar_equipo() {
    this.$emit('enviarEquipo', this.formFields.model_serienumero.value);
  }
  @Watch('formFields')
  onModelTipoCambioChanged(val: any, oldVal: any) {
    this.$emit('input', this.formFields);
  }
  editando: any;
  mounted() {
    if (this.accion_modal == 'EDITAR') {
      this.detalle = true;
      this.formFields.model_serienumero.value = this.serienumero;
      this.formFields.model_tipoeqname.value = this.tipoeqid;
      this.editando = 'Editar';
    }
  }

  @Watch('serienumero')
  onSerienumeroChanged(newValue: any) {
    this.formFields.model_serienumero.value = newValue;
  }

  @Watch('tipoeqid')
  onTipoeqidChanged(newValue: any) {
    this.formFields.model_tipoeqname.value = newValue;
    this.get_equipo_activa();
  }
} //end class
